import { Spinner } from '@frontend/components/common';
import { IGroup } from '@frontend/group/types';
import { Group } from '@frontend/group/utils';
import { StockAvailability } from '@frontend/stock/types';

import { useCategoryCard } from './category-card.controller';

export interface CategoryCardProps {
    category?: IGroup;
    category_id?: string;
    onClick?: (category: IGroup) => void;
    categoryAvailability?: StockAvailability | null;
}

export const CategoryCard = (props: CategoryCardProps) => {
    const viewProps = useCategoryCard(props);
    if (!viewProps.category) {
        return (
            <div className='bg-background-surface outline-border-default inline-flex w-full items-center justify-start gap-2 self-stretch rounded-xl px-4 py-2 outline-1 -outline-offset-1'>
                <Spinner />
            </div>
        );
    }

    const isUnavailable = props.categoryAvailability !== undefined && props.categoryAvailability !== null && !props.categoryAvailability.available;

    return (
        <div
            onClick={() => !isUnavailable && props.onClick && props.onClick(viewProps.category!)}
            key={viewProps.category.id}
            className={`bg-background-surface outline-border-default flex w-full flex-col items-center justify-start gap-2 self-stretch rounded-xl p-3 outline-1 -outline-offset-1 ${isUnavailable ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
            {viewProps.image ? (
                <img
                    className='aspect-square h-full w-12 rounded-lg object-contain'
                    src={viewProps.image}
                    alt={viewProps.category.name}
                />
            ) : null}
            <div className='text-foreground-default justify-end text-base font-medium'>{new Group(viewProps.category).getName(viewProps.locale)}</div>
        </div>
    );
};
